// extracted by mini-css-extract-plugin
export default {"mainWrapper":"BA8QD","menuItem":"Dgv3W"};